import { Box } from '@chakra-ui/react';
import React, { useEffect, createContext } from 'react';
import { ConditionalComponent } from '@components/functionComponent';
import { fetchError } from './helpers/crud';
import { useErrorStore } from './helpers/mainState';
import Reminder from './sections/reminder';
import Upload from './sections/upload';
import History from './sections/history';
import Error from './sections/error';

export const PageContext = createContext();

const UploadSellout = () => {
    const { onChangeErrorStore, errors, isLoadingErrorTable } = useErrorStore();

    const onFetchUploadData = () => {
        fetchError({ onChangeErrorStore });
    };

    useEffect(() => {
        onFetchUploadData();
        // eslint-disable-next-line
    }, []);

    return (
        <PageContext.Provider value={{ onFetchUploadData }}>
            <Box>
                <Reminder />
                <Upload />
                <ConditionalComponent statement={errors?.length}>
                    <Error errors={errors} isLoading={isLoadingErrorTable} />
                </ConditionalComponent>
                <History />
            </Box>
        </PageContext.Provider>
    );
};

export default UploadSellout;
